import { Outlet, useLocation } from "react-router-dom";

import { ErrorBoundary } from "./ErrorBoundary";
import { Footer } from "./Footer";
import { Header } from "./Header";

export function Layout() {
  const location = useLocation();
  return (
    <div className="flex min-h-screen flex-col bg-bg">
      <Header />
      <p className="border-b border-line bg-surface-warm px-6 py-2 text-center text-caption text-ink-soft">
        Interne Buchungsplattform: nur für ausgewählte, mit der Tanzschule Tanzraum assoziierte
        Tanzlehrer:innen. Keine öffentliche Raumvermietung.
      </p>
      <main className="flex-1">
        <ErrorBoundary key={location.pathname}>
          <Outlet />
        </ErrorBoundary>
      </main>
      <Footer />
    </div>
  );
}
